import { render, staticRenderFns } from "./ComplianceChip.vue?vue&type=template&id=29da564a&scoped=true&"
import script from "./ComplianceChip.vue?vue&type=script&lang=js&"
export * from "./ComplianceChip.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceChip.vue?vue&type=style&index=0&id=29da564a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29da564a",
  null
  
)

export default component.exports